import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

function queryErrorHandler(error: unknown): void {
  // error is type unknown because in js, anything can be an error (e.g. throw(5))
  const title = error instanceof Error ? error.message : 'error connecting to server';

  console.error(title);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: queryErrorHandler,
      useErrorBoundary: (error: unknown) =>
        error instanceof AxiosError &&
        (!error?.response?.status ||
          error?.response?.status === 404 ||
          error?.response?.status >= 500),
    },
  },
});
